import React, { forwardRef, useEffect, useState } from "react";
import { Collapse, CollapseProps } from "@mui/material";
import { Box } from "@mui/system";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";

const styles = {
  "@global": {
    "@keyframes fadeIn": {
      from: { opacity: 0 },
      to: { opacity: 1 },
    },
    "@keyframes fadeOut": {
      from: { opacity: 1 },
      to: { opacity: 0 },
    },
  },
  fadeIn: {
    animationName: "$fadeIn",
    animationDuration: "800ms",
    animationTimingFunction: "linear",
    animationFillMode: "forwards",
  },
  fadeOut: {
    animationName: "$fadeOut",
    animationDuration: "300ms",
    animationTimingFunction: "linear",
    animationFillMode: "forwards",
  },
};

const FadeCollapse = forwardRef(function FadeCollapse(
  props: CollapseProps,
  ref
) {
  const { in: inProp, children, ...other } = props;
  const classes: any = useCustomStyles(styles);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    if (!inProp && !exiting) {
      setExiting(true);
    } else if (inProp && exiting) {
      setExiting(false);
    }
  }, [inProp, exiting]);

  return (
    <Collapse ref={ref} in={inProp} {...other}>
      <Box sx={exiting ? classes.fadeOut : classes.fadeIn}>{children}</Box>
    </Collapse>
  );
});

export default FadeCollapse;
